import moment, { Moment } from 'moment';

export const dehumaniseDate = (dateString: string): Moment => {
  const [_day, _month, year] = dateString.split(' ');

  return moment(
    dateString,
    `DD MMM${year != null ? (year.length > 2 ? 'YYYY' : 'YY') : ''}`,
  );
};
